import { useEffect, useRef, useState } from 'react';
import { ReactComponent as QuickNoteIcon } from '../../../assets/svgIcons/Notes_logo.svg';

import { OverlayPanel } from 'primereact/overlaypanel';
import { CustomButton } from '../../../components/CustomButton';
import { Text } from '../../../components/Text';
import EllipsisText from '../../../components/common/EllipsisText/indix';
import { useDispatch, useSelector } from 'react-redux';
function QuickNotes({ handleClick }) {
  const op = useRef(null);
  const { quickNotes, quickNotesCounts, qNotePage, qNoteLimit } = useSelector(
    (state) => state.account,
  );

  const scrollRef = useRef();
  return (
    <div className="card flex justify-content-center">
      <CustomButton
        type="button"
        varient="text"
        icon={<QuickNoteIcon />}
        onClick={(e) => op.current.toggle(e)}
      />
      <OverlayPanel ref={op} className="w-9 m-auto lg:w-3">
        <div style={{ maxHeight: '500px', overflowY: 'auto' }} ref={scrollRef} className="w-full">
          <div className="w-full h-full">
            {quickNotes?.map((item, index) => (
              <div
                key={item.id + index}
                onClick={(e) => {
                  handleClick(item.notes);
                  op.current.toggle(e);
                }}
                className="mb-3 cursor-pointer"
              >
                <Text type={'heading'}>{item?.title}</Text>
                <Text type={'small-text'}>
                  <EllipsisText text={item?.notes} />
                </Text>
              </div>
            ))}
          </div>
        </div>
      </OverlayPanel>
    </div>
  );
}

export default QuickNotes;
